import React from 'react';

import { CallToActionSideBlock } from '@sravni/react-ugc/lib/CallToActionSideBlock';

const text = (
  <>
    Присылайте заполненный бриф на почту{' '}
    <a href={'mailto: sales@sravni.ru'} target={'_blank'} rel="noreferrer">
      sales@sravni.ru
    </a>
  </>
);

export const GetSpecialProject = () => {
  return (
    <CallToActionSideBlock
      title="Хотите спецпроект"
      text={text}
      buttonLabel={'Заполнить бриф'}
      link={'https://sravni-promo.storage.yandexcloud.net/uploads/2023/04/breaf_specproekty_sravni.rtf'}
      linkTarget={'_blank'}
    />
  );
};
